<div class="row">
	<div class="col-lg-12">
		<!-- Main Card -->
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Campaign</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div class="container-fluid">
					<div class="row">
						<div class="col-2">
							<app-side-menu #sideMenu [options]="sideMenuOptions" (tab)="validateForm($event)"></app-side-menu>
						</div>
						<div class="col-10">
							<!-- <div *ngIf="campaignLoading">
                                <app-loading></app-loading>
                            </div> -->
							<div class="row" *ngIf="!campaignLoading && !campaign">
								<div class="col-md-12 ml-auto mr-auto mb-2">
									<h3 class="text-danger">
										<i class="em em-warning"></i>
										{{ campaignMsg }}
									</h3>
								</div>
							</div>
							<!-- TODO: Esto de que es???  -->
							<div class="row" *ngIf="!campaignLoading && campaign">
								<div class="col-md-12 ml-auto mr-auto">
									<h2 class="campaign-row-title">
										<small>
											<span class="badge" [ngClass]="{ 'bg-success': campaign.isActive == 1, 'bg-danger': campaign.isActive == 0 }">
												<span *ngIf="campaign.isActive == 1">Active</span>
												<span *ngIf="campaign.isActive == 0">Inactive</span>
											</span>
											<span class="badge bg-info ml-2" style="margin-left: 5px"> {{ campaign.created | utcToLocal }}</span>
											{{ campaign.name }}
										</small>
										<small *ngIf="order?.type_orderid == '1'">
											<strong> Leads: {{ remaining }} / {{ order?.total_leads }} </strong>
										</small>
										<small *ngIf="order?.type_orderid == '3'">
											<strong> Hours: {{ remaining }} / {{ order?.total_hours }} </strong>
										</small>
									</h2>
								</div>
							</div>
							<div *ngIf="!campaignLoading && campaign" class="row">
								<ng-container *ngIf="activeTab === 'basic'">
									<form [formGroup]="formBasicInfo">
										<div class="container container-margin">
											<div class="row mt-3">
												<div class="col-12">
													<h3>
														<strong>Campaign Information</strong>
													</h3>
												</div>
											</div>
											<hr />
											<div class="row mt-3">
												<div class="col-3">
													<label class="form-label">Campaign name *</label>
													<input type="text" class="form-control money-green" formControlName="name" [class.is-invalid]="formBasicInfo.get('name').touched && formBasicInfo.get('name').invalid" [class.is-valid]="formBasicInfo.get('name').touched && formBasicInfo.get('name').valid" />
												</div>
												<div class="col-3">
													<label class="form-label">Alias owner *</label>
													<select class="form-control money-green" formControlName="alias" [class.is-invalid]="formBasicInfo.get('alias').touched && formBasicInfo.get('alias').invalid" [class.is-valid]="formBasicInfo.get('alias').touched && formBasicInfo.get('alias').valid" (change)="onAliasChange()">
														<option value="">Select alias owner</option>
														<option value="{{ user.alias }}" *ngFor="let user of usersSelect">{{ user.first }} {{ user.last }}</option>
													</select>
												</div>
												<!-- <div class="col-2">
													<label class="form-label">Contract number *</label>
													<select class="form-control money-green" formControlName="contract" [class.is-invalid]="formBasicInfo.get('contract').touched && formBasicInfo.get('contract').invalid" [class.is-valid]="formBasicInfo.get('contract').touched && formBasicInfo.get('contract').valid">
														<option value="">Select contract</option>
														<option value="{{ contract.id }}" *ngFor="let contract of allcontracts">
															{{ contract.id }} - From: {{ contract.startDate | utcToLocal : "LLL,YYYY" }} <span *ngIf="contract.endDate !== '0000-00-00 00:00:00'"> - To: {{ contract.endDate | utcToLocal : "LLL YYYY" }} </span>
														</option>
													</select>
												</div> -->
												<div class="col-2">
													<label class="form-label">Campaign type *</label>
													<select class="form-control money-green" formControlName="campaign_type" [class.is-invalid]="formBasicInfo.get('campaign_type').touched && formBasicInfo.get('campaign_type').invalid" [class.is-valid]="formBasicInfo.get('campaign_type').touched && formBasicInfo.get('campaign_type').valid">
														<option value="D">Default</option>
														<option value="R">Reserve</option>
														<option value="H">Hourly</option>
													</select>
												</div>
												<div class="col-2">
													<label class="form-label">Prospects type *</label>
													<select class="form-control money-green" formControlName="prospects_type" [class.is-invalid]="formBasicInfo.get('prospects_type').touched && formBasicInfo.get('prospects_type').invalid" [class.is-valid]="formBasicInfo.get('prospects_type').touched && formBasicInfo.get('prospects_type').valid">
														<option value="B2B">B2B</option>
														<option value="B2C">B2C</option>
													</select>
												</div>
											</div>

											<div class="row">
												<div class="col-md-2 col-sm-12">
													<label class="form-label">Callback Number *</label>
													<input class="form-control money-green" type="number" formControlName="callback_no" [class.is-invalid]="formBasicInfo.get('callback_no').touched && formBasicInfo.get('callback_no').invalid" [class.is-valid]="formBasicInfo.get('callback_no').touched && formBasicInfo.get('callback_no').valid" />
												</div>
												<div class="col-md-2 col-sm-12">
													<label class="form-label">Time Zone *</label>
													<select class="form-control money-green" formControlName="timezone" [class.is-invalid]="formBasicInfo.get('timezone').touched && formBasicInfo.get('timezone').invalid" [class.is-valid]="formBasicInfo.get('timezone').touched && formBasicInfo.get('timezone').valid">
														<option value="">Select time zone</option>
														<option value="{{ timezone.shortName }}" *ngFor="let timezone of timezones">{{ timezone.name }}</option>
													</select>
												</div>
												<div class="col-md-1 col-sm-12">
													<label class="form-label">Points</label>
													<input class="form-control money-green" type="number" formControlName="points" />
												</div>
												<div class="col-md-2 col-sm-12">
													<label class="form-label">Industry *</label>
													<select class="form-control money-green" formControlName="industry" [class.is-invalid]="formBasicInfo.get('industry').touched && formBasicInfo.get('industry').invalid" [class.is-valid]="formBasicInfo.get('industry').touched && formBasicInfo.get('industry').valid">
														<option value="">Select industry</option>
														<option *ngFor="let industry of industries" [value]="industry.id">{{ industry.description }}</option>
													</select>
												</div>
												<div class="col-md-5 col-sm-12">
													<label class="form-label">Appointment Type *</label>
													<div *ngFor="let type of types" style="padding-top: 10px">
														<span *ngIf="!typesContain(type.id)" class="form-check form-switch"> <input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" (click)="type.selected = !type.selected; setTypes(type.id)" />{{ type.description }} </span>
														<span *ngIf="typesContain(type.id)" class="form-check form-switch"> <input class="form-check-input" type="checkbox" role="switch" id="SwitchCheck1" checked (click)="type.selected = !type.selected; setTypes(type.id)" />{{ type.description }} </span>
													</div>
												</div>
											</div>

											<div class="row">
												<div class="col-md-3 col-sm-3">
													<label class="form-label">Source *</label>
													<select class="form-control money-green" formControlName="source" [class.is-invalid]="formBasicInfo.get('source').touched && formBasicInfo.get('source').invalid" [class.is-valid]="formBasicInfo.get('source').touched && formBasicInfo.get('source').valid">
														<option value="">Select source</option>
														<option value="T3 Direct">T3 Direct</option>
														<option value="401k Depot">401k Depot</option>
														<option value="Toplead">Toplead</option>
													</select>
												</div>
												<div class="col-3">
													<label class="form-label">Appointments per Month *</label>
													<input type="number" class="form-control money-green" formControlName="appts_month" [class.is-invalid]="formBasicInfo.get('appts_month').touched && formBasicInfo.get('appts_month').invalid" [class.is-valid]="formBasicInfo.get('appts_month').touched && formBasicInfo.get('appts_month').valid" />
												</div>
												<div class="col-1">
													<label class="form-label">Week 1</label>
													<input type="number" class="form-control money-green" formControlName="week_1" />
												</div>
												<div class="col-1">
													<label class="form-label">Week 2</label>
													<input type="number" class="form-control money-green" formControlName="week_2" />
												</div>
												<div class="col-1">
													<label class="form-label">Week 3</label>
													<input type="number" class="form-control money-green" formControlName="week_3" />
												</div>
												<div class="col-1">
													<label class="form-label">Week 4</label>
													<input type="number" class="form-control money-green" formControlName="week_4" />
												</div>
											</div>
											<br />
											<!-- TODO: Change the way to show or not lead cost to users -->
											<div class="row">
												<div class="col-6" *ngIf="user.Role === 'SADM'">
    												<app-pricing [campaignId]="campaignId"></app-pricing>
												</div>
												<div class="col-6">
													<div class="row">
														<h3>Notes</h3>
														<div class="col-12">
															<label class="form-label">Billing Notes</label>
															<input type="text" class="form-control money-green" placeholder="Billing Notes" formControlName="billing_notes" />
														</div>
													</div>

													<div class="row">
														<div class="col-12">
															<label class="form-label">Campaign Notes</label>
															<textarea rows="5" class="form-control money-green" placeholder="Campaign notes" formControlName="campaign_notes"></textarea>
														</div>
													</div>
												</div>
											</div>

											<div class="row" *ngIf="user.Role === 'SADM' && campaign.campaign_type === 'H'">
												<div class="col-3">
													<label class="form-label">Start Date:</label>
													<div class="input-group mb-3 margin-b-0">
														<div class="input-group mb-3">
															<span class="input-group-text" id="basic-addon1">
																<i class="bx bx-calendar"></i>
															</span>
															<input type="date" step="1" class="form-control money-green" formControlName="hourly_start_date" />
														</div>
													</div>
												</div>
												<div class="col-3">
													<label class="form-label">Total Hours</label>
													<div class="input-group mb-3 margin-b-0">
														<div class="input-group mb-3">
															<span class="input-group-text" id="basic-addon1">
																<i class="bx bx-time"></i>
															</span>
															<input type="number" step="1" class="form-control money-green" formControlName="budget_hours" />
														</div>
													</div>
												</div>

												<div class="col-3">
													<label class="form-label">Worked Hours</label>
													<div class="input-group mb-3 margin-b-0">
														<div class="input-group mb-3">
															<span class="input-group-text" id="basic-addon1">
																<i class="bx bx-time"></i>
															</span>
															<input type="text" class="form-control money-green" formControlName="total_worked_time" disabled />
														</div>
													</div>
												</div>

												<div class="col-3">
													<button class="btn btn-success" (click)="addWorkedHours(add_hours_modal)" style="top: 27px">
														<i class="bx bx-alarm-add"></i>
														Add Worked Hours
													</button>
												</div>
											</div>
											<br />
											<div class="row">
												<div class="col-12" align="right">
													<button class="btn btn-success" (click)="updateCampaignConfirm()">
														<i class="fa fa-save"></i>
														Save
													</button>
												</div>
											</div>
										</div>
									</form>
								</ng-container>

								<ng-container *ngIf="activeTab === 'criteria'">
									<app-campaign-criteria #criteria [campaign]="campaign" style="width: 100%"></app-campaign-criteria>
								</ng-container>

								<ng-container *ngIf="activeTab === 'call_sheet'">
									<div class="container container-margin">
										<form [formGroup]="formCampaignInfo">
											<div class="row">
												<div class="col-12">
													<h3>
														<strong>Call sheet</strong>
													</h3>
												</div>
											</div>
											<hr />
											<div class="row">
												<div class="col-md-6 mb-3">
													<ul role="tablist" class="nav nav-pills justify-content-start">
														<li class="nav-item">
															<span (click)="callSheetTab = 'bio'" [class.active]="callSheetTab === 'bio'" class="nav-link grey call-sheet-tab-btn info-toggle" role="tab" aria-expanded="true"> Bio/Script </span>
														</li>
														<li class="nav-item">
															<span (click)="callSheetTab = 'notes'" [class.active]="callSheetTab === 'notes'" class="nav-link grey call-sheet-tab-btn info-toggle" role="tab" aria-expanded="true"> Notes </span>
														</li>
														<li class="nav-item">
															<span (click)="callSheetTab = 'details'" [class.active]="callSheetTab === 'details'" class="nav-link grey call-sheet-tab-btn info-toggle" role="tab" aria-expanded="false"> Company Info </span>
														</li>
													</ul>
												</div>
											</div>
											<ng-container *ngIf="callSheetTab === 'notes'">
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Who's Attending the Meetings?</label>
															<div class="value-txt">
																<input formControlName="attending" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">General Notes:</label>
															<div class="value-txt text-danger">
																<textarea rows="4" cols="50" formControlName="notes" class="form-control border-input money-green" type="text"></textarea>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Scheduling Notes:</label>
															<div class="value-txt">
																<textarea rows="4" cols="50" formControlName="scheduling" class="form-control border-input money-green" type="text"></textarea>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Qualifying Questions:</label>
															<div class="value-txt text-danger">
																<textarea rows="4" cols="50" formControlName="questions" class="form-control border-input money-green" type="text"></textarea>
															</div>
														</div>
													</div>
												</div>
											</ng-container>

											<ng-container *ngIf="callSheetTab === 'bio'">
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Script:</label>
															<div class="textarea-like" [innerHTML]="bioData.script" (click)="openTextEditor('script')"></div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Who We Are:</label>
															<div class="textarea-like" [innerHTML]="bioData.who_we_are" (click)="openTextEditor('who_we_are')"></div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">What We Do:</label>
															<div class="textarea-like" [innerHTML]="bioData.what_we_do" (click)="openTextEditor('what_we_do')"></div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Why Us?</label>
															<div class="textarea-like" [innerHTML]="bioData.why_us" (click)="openTextEditor('why_us')"></div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-12 col-sm-12">
														<div class="form-group">
															<label class="call-sheet-title">Email Template</label>
															<div class="textarea-like" [innerHTML]="bioData.email_template" (click)="openTextEditor('email_template')"></div>
														</div>
													</div>
												</div>
											</ng-container>

											<ng-container *ngIf="callSheetTab === 'details'">
												<div class="row">
													<div class="col-md-6 col-sm-6">
														<div class="form-group">
															<label class="call-sheet-title">Company Website:</label>
															<div class="value-txt">
																<input formControlName="website_url" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
													<div class="col-md-6 col-sm-6">
														<div class="form-group">
															<label class="call-sheet-title">Additional Calendar URL:</label>
															<div class="value-txt">
																<input formControlName="additional_calendar_url" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6 col-sm-6">
														<div class="form-group">
															<label class="call-sheet-title">Address 1:</label>
															<div class="value-txt">
																<input formControlName="address_1" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
													<div class="col-md-6 col-sm-6">
														<div class="form-group">
															<label class="call-sheet-title">Address 2:</label>
															<div class="value-txt">
																<input formControlName="address_2" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-md-6 col-sm-6">
														<div class="form-group">
															<label class="call-sheet-title">City:</label>
															<div class="value-txt">
																<input formControlName="city" class="form-control border-input money-green" type="text" />
															</div>
														</div>
													</div>
													<div class="col-md-2 col-sm-2">
														<div class="form-group">
															<label class="call-sheet-title">State:</label>
															<div class="value-txt">
																<input formControlName="state" class="form-control border-input money-green" type="text" maxlength="2" />
															</div>
														</div>
													</div>
													<div class="col-md-4 col-sm-4">
														<div class="form-group">
															<label class="call-sheet-title">Zip:</label>
															<div class="value-txt">
																<input formControlName="zip" class="form-control border-input money-green" type="text" maxlength="6" />
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</form>
										<div class="row">
											<div class="col-12" align="right">
												<button class="btn btn-success" (click)="updateCampaignConfirm()"><i class="fa fa-save"></i> Save</button>
											</div>
										</div>
									</div>
								</ng-container>
								<ng-container *ngIf="activeTab === 'log'">
									<div *ngIf="dispoLogLoading">
										<app-loading></app-loading>
									</div>
									<div *ngIf="!dispoLogLoading" class="col-md-12 ml-auto mr-auto">
										<div class="row">
											<div class="col-md-4 ml-auto mr-auto">
												<div class="title">
													<h3>
														<i class="ri-git-repository-line"></i>
														Dispo Log
													</h3>
												</div>
											</div>
											<div class="col-md-2 ml-auto mr-auto">
												<div class="title">
													<select [(ngModel)]="dispoSearchMonth" name="dispoSearchMonth" class="form-control money-green">
														<option value="{{ month.number }}" *ngFor="let month of months">
															{{ month.shortName }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-md-2 ml-auto mr-auto">
												<div class="title">
													<select [(ngModel)]="dispoSearchDay" name="dispoSearchDay" class="form-control money-green">
														<option value="{{ day }}" *ngFor="let day of days">
															{{ day }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-md-2 ml-auto mr-auto">
												<div class="title">
													<select [(ngModel)]="dispoSearchYear" name="dispoSearchYear" class="form-control money-green">
														<option value="{{ year }}" *ngFor="let year of years">
															{{ year }}
														</option>
													</select>
												</div>
											</div>
											<div class="col-md-2">
												<div class="title">
													<button (click)="getCampaignDispoLogByDate()" class="btn btn-secondary" type="submit"><i class="ri-search-line"></i> Search</button>
												</div>
											</div>
										</div>
										<div *ngIf="!dispoLogLoading && dispoLog && !dispoLog.length" class="col-md-12 ml-auto mr-auto">
											<div class="row">
												<div class="col-md-12 ml-auto mr-auto">
													<div class="title text-center">
														<small>No Logs Found.</small>
													</div>
												</div>
											</div>
										</div>
										<div *ngIf="!dispoLogLoading && dispoLog && dispoLog.length" class="table-responsive">
											<table class="table table-hover">
												<thead>
													<tr>
														<th class="text-center">{{ dispoLog.length }}</th>
														<th>Date / Time</th>
														<th>Dispo</th>
														<th>User</th>
														<th>Phone</th>
														<th>Company</th>
														<th>&nbsp;</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let dispo of dispoLog; let i = index" [attr.data-index]="i" class="ng-star-inserted grid-row">
														<td class="text-center">{{ i + 1 }}</td>
														<td>{{ dispo.date | utcToLocal : "short" }}</td>
														<td class="bg-dark text-white">{{ dispo.dispo }}</td>
														<td>{{ dispo.user_login }}</td>
														<td>
															<a href="tel://+1{{ dispo.primary_phone }}">{{ dispo.primary_phone }}</a>
														</td>
														<td class="company-name">{{ dispo.company_name }}</td>
														<td class="text-right campaign-actions">
															<i class="em em-spiral_note_pad" ngbPopover="{{ dispo.notes }}" placement="left" triggers="mouseenter:mouseleave"></i>
															<app-loading *ngIf="dialLoading"></app-loading>
															<i *ngIf="!dialLoading" (click)="dialProspect(dispo.campaign, dispo.primary_phone)" class="em em-eye ml-3"></i>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</ng-container>

								<ng-container *ngIf="activeTab === 'stats'">
									<div class="container" *ngIf="loadingStats">
										<app-loading></app-loading>
									</div>
									<div class="container" *ngIf="!loadingStats">
										<div class="row">
											<div class="col-md-4 col-sm-4">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #48c78e; color: white">
														<strong>Available Records</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">{{ campaign.total_records }}</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #f14668; color: white">
														<strong>All Dispo's</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">{{ dispoCount }}</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Face to face</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">{{ leadfCount }}</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Phone</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">{{ leadpCount }}</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Zoom</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">{{ leadZoomCount }}</h2>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4 col-sm-4">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #48c78e; color: white">
														<strong>Available Records</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">
															{{ campaign.total_records }}
														</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #f14668; color: white">
														<strong>All Dispo's</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">
															{{ dispoCount }}
														</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Face to face</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">
															{{ leadfCount }}
														</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Phone</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">
															{{ leadpCount }}
														</h2>
													</div>
												</div>
											</div>
											<div class="col-md-2 col-sm-2">
												<div class="card">
													<div class="card-header" align="center" style="background-color: #3e8ed0; color: white">
														<strong>Zoom</strong>
													</div>
													<div class="card-body" align="center">
														<h2 class="card-title" style="margin: 0px; font-weight: 700">
															{{ leadZoomCount }}
														</h2>
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
								<ng-container *ngIf="activeTab === 'calendar'">
									<div class="row">
										<div class="col-12">
											<div class="row">
												<div class="col-xl-12">
													<div class="card card-h-100">
														<div class="card-body">
															<div id="calendar"></div>
															<full-calendar [options]="calendarOptions"></full-calendar>
														</div>
													</div>
												</div>
												<!-- end col -->
											</div>
											<!--end row-->

											<div style="clear: both"></div>

											<!-- Add New Event MODAL -->
											<ng-template #modalShow let-modal>
												<div class="modal-header p-3 bg-soft-info">
													<h5 class="modal-title" id="modal-title">Add Event</h5>
													<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="closeEventModal()"></button>
												</div>
												<div class="modal-body p-4">
													<form class="needs-validation" name="event-form" id="form-event" novalidate (ngSubmit)="saveEvent()" [formGroup]="formData">
														<div class="row event-form">
															<div class="col-12">
																<div class="mb-3">
																	<label class="form-label">Type</label>
																	<select class="form-select" name="category" formControlName="category" [ngClass]="{ 'is-invalid': submitted && form['category'].errors }" id="event-category" required>
																		<option value="bg-soft-danger">Danger</option>
																		<option value="bg-soft-success">Success</option>
																		<option value="bg-soft-primary">Primary</option>
																		<option value="bg-soft-info">Info</option>
																		<option value="bg-soft-dark">Dark</option>
																		<option value="bg-soft-warning">Warning</option>
																	</select>
																	<div *ngIf="submitted && form['category'].errors" class="invalid-feedback">
																		<div *ngIf="form['category'].errors['required']">This value is required</div>
																	</div>
																</div>
															</div>
															<!--end col-->
															<div class="col-12">
																<div class="mb-3">
																	<label class="form-label">Event Name</label>
																	<input class="form-control" placeholder="Enter event name" type="text" name="title" id="event-title" required value="" formControlName="title" [ngClass]="{ 'is-invalid': submitted && form['title'].errors }" />
																	<div *ngIf="submitted && form['title'].errors" class="invalid-feedback">
																		<span *ngIf="form['title'].errors['required']"> This value is required.</span>
																	</div>
																</div>
															</div>
															<!--end col-->
															<div class="col-12">
																<div class="mb-3">
																	<label>Event Date</label>
																	<div class="input-group">
																		<!-- <input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true" placeholder="Select date"> -->
																		<input class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true" placeholder="Select date" />
																	</div>
																</div>
															</div>
															<!--end col-->
															<div class="col-12" id="event-time">
																<div class="row">
																	<div class="col-6">
																		<div class="mb-3">
																			<label class="form-label">Start Time</label>
																			<div class="input-group">
																				<input class="form-control flatpickr-input" type="text" placeholder="Select start time" mwlFlatpickr [noCalendar]="true" [enableTime]="true" [dateFormat]="'H:i'" />
																			</div>
																		</div>
																	</div>
																	<div class="col-6">
																		<div class="mb-3">
																			<label class="form-label">End Time</label>
																			<div class="input-group">
																				<input class="form-control flatpickr-input" type="text" placeholder="Select end time" mwlFlatpickr [noCalendar]="true" [enableTime]="true" [dateFormat]="'H:i'" />
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<!--end col-->
															<div class="col-12">
																<div class="mb-3">
																	<label for="event-location">Location</label>
																	<div>
																		<input type="text" class="form-control" name="event-location" id="event-location" placeholder="Event location" />
																	</div>
																</div>
															</div>
															<!--end col-->
															<div class="col-12">
																<div class="mb-3">
																	<label class="form-label">Description</label>
																	<textarea class="form-control" id="event-description" placeholder="Enter a description" rows="3" spellcheck="false"></textarea>
																</div>
															</div>
															<!--end col-->
														</div>
														<div class="hstack gap-2 justify-content-end">
															<button type="submit" class="btn btn-success" id="btn-save-event">Add Event</button>
														</div>
													</form>
												</div>
											</ng-template>
											<!-- end modal-->

											<!-- Edit event modal -->
											<ng-template #editmodalShow let-modal>
												<div class="modal-header p-3 bg-soft-info">
													<h5 class="modal-title" id="modal-title">Event</h5>
													<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
												</div>
												<div class="modal-body p-4">
													<form [formGroup]="formEditData" (ngSubmit)="editEventSave()">
														<div class="row event-form">
															<div class="col-12">
																<label>Name</label>
																<div class="mb-3">
																	<input class="form-control" placeholder="Insert Event Name" type="text" name="editTitle" formControlName="editTitle" readonly />
																</div>
															</div>
															<!--end col-->
															<div class="col-12">
																<div class="mb-3">
																	<label>Date</label>
																	<div class="input-group">
																		<input class="form-control" type="text" name="startDate" formControlName="startDate" readonly />
																	</div>
																</div>
															</div>
															<!--end col-->

															<div class="col-12">
																<div class="mb-3">
																	<label>End Date</label>
																	<div class="input-group">
																		<input class="form-control" type="text" name="endDate" formControlName="endDate" readonly />
																	</div>
																</div>
															</div>
															<!--end col-->
														</div>
													</form>

													<div class="row">
														<div class="col-6">
															<form [formGroup]="appointmentForm" (ngSubmit)="scheduleMeeting()">
																<input type="hidden" id="titleEvent" formControlName="titleEvent" />
																<input type="hidden" id="appointmentTime" formControlName="appointmentTime" />
																<input type="hidden" id="endAppointmentTime" formControlName="endAppointmentTime" />
																<button class="btn btn-success" type="submit" id="schedule-button">Add to Google Calendar</button>
															</form>
														</div>
														<div class="col-6">
															<button class="btn btn-primary" type="button" (click)="donloadICS()">Add to Outlook</button>
														</div>
													</div>
												</div>
											</ng-template>
											<!-- end modal-->
										</div>
									</div>
									<!-- end row-->
								</ng-container>
								<ng-container *ngIf="activeTab === 'contract_rules'">
									<app-contract style="width: 100%" [campaign]="campaign"></app-contract>
								</ng-container>
								<ng-container *ngIf="activeTab === 'Assigned_users'">
									<app-campaign-employee style="width: 100%" [campaignID]="campaignId"></app-campaign-employee>
								</ng-container>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!--end row-->

<ng-template #textEditor let-modal>
	<div class="modal-header p-3 bg-soft-info">
		<h5 class="modal-title" id="modal-title">Editing field {{ getEditField(selectedFieldToEdit) }}</h5>
		<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body p-4">
		<div class="row" *ngIf="getEditField(selectedFieldToEdit) === 'Email Template'">
			<div class="col-12">
				<label class="lbl-editor">Subject:</label>
				<input type="text" class="form-control input-editor" [(ngModel)]="email_template.subject" placeholder="Subject" />
			</div>
		</div>
		<br />
		<!-- <div class="row" *ngIf="getEditField(selectedFieldToEdit) === 'Email Template'">
			<div class="col-12">
				<label class="lbl-editor">From:</label>
				<input type="text" class="form-control input-editor" [(ngModel)]="email_template.from" placeholder="Email from" readonly>
			</div>
 		</div>
		<div class="row" *ngIf="getEditField(selectedFieldToEdit) === 'Email Template'">
			<div class="col-12">
				<label class="lbl-editor">To:</label>
				<input type="email" class="form-control input-editor" [(ngModel)]="email_template.to" placeholder="Email to">
			</div>
 		</div>

		<div class="row" *ngIf="getEditField(selectedFieldToEdit) === 'Email Template'">
			<div class="col-12">
				<label class="lbl-editor">CC:</label>
				<input type="text" class="form-control input-editor" [(ngModel)]="email_template.cc" placeholder="CC">
			</div>
 		</div>
		<div class="row" *ngIf="getEditField(selectedFieldToEdit) === 'Email Template'">
			<div class="col-12">
				<label class="lbl-editor">BCC:</label>
				<input type="text" class="form-control input-editor" [(ngModel)]="email_template.bcc" placeholder="BCC">
			</div>
 		</div> -->
		<div class="row">
			<div class="col-12">
				<editor
					apiKey="pyty9d0c48l4o98li8zhvhbxyy5reipmmgmuawz495edqlix"
					[init]="{
						menubar: 'edit insert format',
						toolbar: 'undo redo | styles | bold italic underline | forecolor backcolor| alignleft aligncenter alignright alignjustify | outdent indent'
					}"
					[(ngModel)]="textoEnriquecido"
				>
				</editor>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="saveRichText()">Save</button>
	</div>
</ng-template>

<ng-template #add_hours_modal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Add Hours</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-12">
				<label for="">Hours</label>
				<input type="number" class="form-control" [(ngModel)]="addedHours" />
			</div>
		</div>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Add Hours</button>
	</div>
</ng-template>
